import React from 'react'
import styled from '@emotion/styled'
import {Flex} from '@vio/atlas/helpers/Flex'
import {cssTheme} from '@vio/atlas/themes'
import {TrustPilotWidgetTheme} from '@vio/shared/src/search/footer/TrustpilotWidget'

import {AppRatingsAndReviews} from '../AppRatingsAndReviews'
import {TrustpilotDetails} from '../TrustpilotDetails'

const SocialProofWrapper = styled(Flex.Row)`
  padding-top: ${cssTheme.layout.spacing.s500};
`

const VerticalDivider = styled.div`
  background-color: ${cssTheme.colors.border.neutral.c200};
  height: 24px;
  width: 1px;
`

interface Props {
  trustPilotTheme?: TrustPilotWidgetTheme
}

export const SocialProof: React.FC<Props> = ({trustPilotTheme}) => {
  return (
    <SocialProofWrapper justifyContent="center" alignItems="center" gap="s800">
      <AppRatingsAndReviews variant="AppStore" />
      <VerticalDivider />
      <TrustpilotDetails section="Hero" trustPilotTheme={trustPilotTheme} />
      <VerticalDivider />
      <AppRatingsAndReviews variant="GooglePlay" />
    </SocialProofWrapper>
  )
}
